import "./style.scss";

import PercentIcon from "@mui/icons-material/Percent";
import { Tooltip } from "@mui/material";
import CurrencyIcon from "components/shared/CurrencyIcon";
import { PortalType } from "contexts/portal.context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import type { ChannelType } from "store/types";
import { ChannelCalculationMethod } from "store/types";
import { EPortalType } from "store/types";

import type { ChannelKind } from "..";
import { channelKindsI18n, channelTypesI18n } from "..";
import type { IChannel } from "../types";

interface IChannelTags {
    channelData: IChannel;
}

/**
 * This component render channel tags
 */
const ChannelTags = ({ channelData }: IChannelTags) => {
    const portalType = useContext(PortalType);
    const [t] = useTranslation();

    return (
        <div className="channel-tags">
            {channelData.calculationMethod === ChannelCalculationMethod.SUBSCRIPTION && (
                <Tooltip title={t("NewChannel.Subscription")}>
                    <div className="channel-tag subscription">{t("NewChannel.Subscription")}</div>
                </Tooltip>
            )}
            {portalType === EPortalType.BOOK && (
                <Tooltip
                    title={`${t("Channels.CurrentSalesFormat")}: ${
                        channelKindsI18n()[channelData.kind as keyof Record<ChannelKind, string>]
                    }`}
                    arrow
                >
                    <div className="channel-tag category">
                        {channelKindsI18n()[channelData.kind as keyof Record<ChannelKind, string>]}
                    </div>
                </Tooltip>
            )}
            {portalType === EPortalType.BOOK && (
                <Tooltip
                    title={
                        channelData.calculationMethod === ChannelCalculationMethod.PROPORTIONAL
                            ? t("NewChannel.Proportional")
                            : channelData.calculationMethod === ChannelCalculationMethod.SUBSCRIPTION
                              ? t("NewChannel.Subscription")
                              : t("NewChannel.Package")
                    }
                >
                    <div className="channel-tag category">
                        {channelData.calculationMethod === ChannelCalculationMethod.PROPORTIONAL ? (
                            <PercentIcon />
                        ) : (
                            <CurrencyIcon />
                        )}
                    </div>
                </Tooltip>
            )}
            {portalType !== EPortalType.BOOK && (
                <Tooltip
                    title={`${t("Channels.CalculationBase")}: ${
                        channelTypesI18n()[channelData.type as keyof Record<ChannelType, string>]
                    }`}
                >
                    <div className="channel-tag type">
                        {channelTypesI18n()[channelData.type as keyof Record<ChannelType, string>]}
                    </div>
                </Tooltip>
            )}
            {!!channelData.hasMilestones && (
                <Tooltip title={`${t("Channels.HasMilestonesYes")}`}>
                    <div className="channel-tag hasMilestones">{t("Channels.Milestones")}</div>
                </Tooltip>
            )}
        </div>
    );
};

export default ChannelTags;
